import { AxiosInstance } from 'axios';

import { Appointment } from '../Appointments/types';

export const rescheduleAppointment = (
  axiosInstance: AxiosInstance,
  id: string,
  params: Partial<Appointment>,
) => {
  return axiosInstance
    .post<{ appointment: Appointment }>('/appointments/reschedule', {
      id,
      ...params,
    })
    .then(d => d.data.appointment);
};
